import type { ReactNode } from 'react';
import { useBearAuthSession } from '@bear-auth/react';

import type { AuthUser } from '../../schemas/oauth';
import { AuthLoader } from '../AuthLoader';
import { LoginPage } from '../LoginPage';
import { useHandleExtensionLogin } from './hooks/useHandleExtensionLogin';

export const Authorized = ({ children }: { children: ReactNode }) => {
    const { status } = useBearAuthSession<AuthUser>();
    const extensionLoginResult = useHandleExtensionLogin();

    if (extensionLoginResult.isLoading) {
        return <AuthLoader />;
    }

    switch (status) {
        case 'authenticated':
            return <>{children}</>;

        case 'refreshing':
        case 'retrieving':
        case 'signing-out':
            return <AuthLoader />;

        case 'unauthenticated':
            return <LoginPage />;
    }
};
